module.exports = __webpack_public_path__ + "static/media/user_3.e2654c4e.ico";